import { combineEpics } from 'redux-observable'
import { createListable } from 'listable'
import { createId } from 'utils'
import options from './config'
import { createEffects } from './effects'
import * as customActions from './actions'
import { moduleName } from './actions/types'
import customReducer from './reducer'


const listableModule = createListable({
  name: moduleName,
  config: options,
  customActions,
  customReducer,
})

export const config = listableModule.options
export const actions = listableModule.actions

export const effects = combineEpics(
  createEffects(listableModule.actions),
  listableModule.effects,
)

export const reducer = listableModule.reducer
export const types = listableModule.types

export const constants = {
  ...listableModule.constants,
  PATH_ALL: `/drivers`,
  PATH_ADD: `/drivers/add`,
  PATH_SINGLE: `/drivers`,

  ROUTE_ALL: `/drivers`,
  ROUTE_ADD: `/drivers/add`,
  ROUTE_SINGLE: `/drivers/:id`,
}

export const createDefaultModel = () => ({
  ...listableModule.defaultItemState,
  id: createId(),
})
